(() => {
  class AyabeOrder {
    constructor(root) {
      this.root = root;
      this.config = JSON.parse(root.querySelector('[data-ayabe-config]').textContent);
      this.state = {};
      this.steps = [];
      this.current = 0;
      this.bind();
      this.rebuildSteps();
      this.setMinimumDates();
      this.render();
      this.root.__ayabeOrder = this;
    }

    bind() {
      this.root.addEventListener('change', (event) => {
        const field = event.target;
        if (!field.name) return;
        this.state[field.name] = field.value;
        this.clearError();
        if (field.name === 'fulfillment') this.rebuildSteps();
        if (field.name === 'pickup_date') this.updatePickupTimes();
        if (field.name === 'delivery_date') this.updateDeliveryTimes();
        if (field.name === 'product_type') this.renderProductPreview();
        if (field.name === 'price') this.renderProductPreview();
      });
      this.root.addEventListener('input', (event) => {
        if (event.target.name) this.state[event.target.name] = event.target.value;
      });
      this.root.querySelectorAll('[data-next]').forEach((button) => button.addEventListener('click', () => this.next()));
      this.root.querySelectorAll('[data-back]').forEach((button) => button.addEventListener('click', () => this.back()));
      this.root.querySelector('[data-check-postcode]')?.addEventListener('click', () => this.checkPostcode(true));
      this.root.querySelector('[data-submit]')?.addEventListener('click', () => this.submit());
      this.root.querySelector('[data-calendar-prev]')?.addEventListener('click', () => this.changeDeliveryCalendarMonth(-1));
      this.root.querySelector('[data-calendar-next]')?.addEventListener('click', () => this.changeDeliveryCalendarMonth(1));
      this.root.querySelector('[data-calendar-days]')?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-calendar-date]');
        if (!button || button.disabled) return;
        const deliveryDate = this.root.querySelector('[name="delivery_date"]');
        deliveryDate.value = button.dataset.calendarDate;
        this.state.delivery_date = button.dataset.calendarDate;
        this.clearError();
        this.updateDeliveryTimes();
        this.renderDeliveryCalendar();
      });
    }

    setMinimumDates() {
      const now = new Date();
      const formatDate = (date) => [
        date.getFullYear(),
        String(date.getMonth() + 1).padStart(2, '0'),
        String(date.getDate()).padStart(2, '0')
      ].join('-');
      const afterCutoff = now.getHours() >= 18;
      const earliestDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      const earliestValue = formatDate(earliestDate);
      const pickupDate = this.root.querySelector('[name="pickup_date"]');
      if (pickupDate) {
        pickupDate.min = earliestValue;
        pickupDate.dataset.earliestPickup = earliestValue;
        pickupDate.dataset.afterCutoff = afterCutoff ? 'true' : 'false';
      }
      const deliveryDate = this.root.querySelector('[name="delivery_date"]');
      if (deliveryDate) {
        deliveryDate.min = earliestValue;
        deliveryDate.dataset.earliestDelivery = earliestValue;
        deliveryDate.dataset.afterCutoff = afterCutoff ? 'true' : 'false';
      }
      this.updatePickupTimes();
      this.updateDeliveryTimes();
      this.renderDeliveryCalendar();
    }

    updatePickupTimes() {
      const pickupDate = this.root.querySelector('[name="pickup_date"]');
      const pickupTime = this.root.querySelector('[name="pickup_time"]');
      if (!pickupDate || !pickupTime) return;
      const earliestSelected = pickupDate.value && pickupDate.value === pickupDate.dataset.earliestPickup;
      const afterCutoff = pickupDate.dataset.afterCutoff === 'true';
      const firstSlot = pickupTime.querySelector('option[value="10:00～12:00"]');
      const secondSlot = pickupTime.querySelector('option[value="12:00～14:00"]');
      if (firstSlot) firstSlot.disabled = earliestSelected;
      if (secondSlot) secondSlot.disabled = earliestSelected && afterCutoff;
      const selectedOption = pickupTime.options[pickupTime.selectedIndex];
      if (selectedOption?.disabled) {
        pickupTime.value = '';
        delete this.state.pickup_time;
      }
      const note = this.root.querySelector('[data-pickup-time-note]');
      if (note) note.textContent = earliestSelected
        ? afterCutoff
          ? '18時以降のご注文は、翌日の14:00以降の時間帯を選択してください。'
          : '翌日は12:00以降の時間帯を選択してください。'
        : '';
    }

    updateDeliveryTimes() {
      const deliveryDate = this.root.querySelector('[name="delivery_date"]');
      const deliveryTime = this.root.querySelector('[name="delivery_time"]');
      if (!deliveryDate || !deliveryTime) return;
      const earliestSelected = deliveryDate.value && deliveryDate.value === deliveryDate.dataset.earliestDelivery;
      const afterCutoff = deliveryDate.dataset.afterCutoff === 'true';
      const firstSlot = deliveryTime.querySelector('option[value="9:00～12:00"]');
      const secondSlot = deliveryTime.querySelector('option[value="12:00～14:00"]');
      if (firstSlot) firstSlot.disabled = earliestSelected;
      if (secondSlot) secondSlot.disabled = earliestSelected && afterCutoff;
      const selectedOption = deliveryTime.options[deliveryTime.selectedIndex];
      if (selectedOption?.disabled) {
        deliveryTime.value = '';
        delete this.state.delivery_time;
      }
      const note = this.root.querySelector('[data-delivery-time-note]');
      if (note) note.textContent = earliestSelected
        ? afterCutoff
          ? '18時以降のご注文は、翌日の14:00以降の時間帯を選択してください。'
          : '翌日は12:00以降の時間帯を選択してください。'
        : '';
    }

    formatLocalDate(date) {
      return [
        date.getFullYear(),
        String(date.getMonth() + 1).padStart(2, '0'),
        String(date.getDate()).padStart(2, '0')
      ].join('-');
    }

    parseLocalDate(value) {
      const [year, month, day] = String(value || '').split('-').map(Number);
      return new Date(year, month - 1, day);
    }

    changeDeliveryCalendarMonth(offset) {
      const deliveryDate = this.root.querySelector('[name="delivery_date"]');
      if (!deliveryDate?.dataset.earliestDelivery) return;
      if (!this.deliveryCalendarMonth) {
        const earliest = this.parseLocalDate(deliveryDate.dataset.earliestDelivery);
        this.deliveryCalendarMonth = new Date(earliest.getFullYear(), earliest.getMonth(), 1);
      }
      this.deliveryCalendarMonth = new Date(
        this.deliveryCalendarMonth.getFullYear(),
        this.deliveryCalendarMonth.getMonth() + offset,
        1
      );
      this.renderDeliveryCalendar();
    }

    renderDeliveryCalendar() {
      const deliveryDate = this.root.querySelector('[name="delivery_date"]');
      const grid = this.root.querySelector('[data-calendar-days]');
      const monthLabel = this.root.querySelector('[data-calendar-month]');
      if (!deliveryDate || !grid || !monthLabel || !deliveryDate.dataset.earliestDelivery) return;

      const earliest = this.parseLocalDate(deliveryDate.dataset.earliestDelivery);
      const minimumMonth = new Date(earliest.getFullYear(), earliest.getMonth(), 1);
      const maximumMonth = new Date(earliest.getFullYear(), earliest.getMonth() + 11, 1);
      if (!this.deliveryCalendarMonth || this.deliveryCalendarMonth < minimumMonth) {
        this.deliveryCalendarMonth = minimumMonth;
      }
      if (this.deliveryCalendarMonth > maximumMonth) this.deliveryCalendarMonth = maximumMonth;

      const year = this.deliveryCalendarMonth.getFullYear();
      const month = this.deliveryCalendarMonth.getMonth();
      monthLabel.textContent = `${year}年${month + 1}月`;
      grid.innerHTML = '';

      const firstWeekday = new Date(year, month, 1).getDay();
      for (let index = 0; index < firstWeekday; index += 1) {
        const blank = document.createElement('span');
        blank.className = 'ayabe-calendar__blank';
        grid.appendChild(blank);
      }

      const unavailableDates = new Set((this.config.deliveryUnavailableDates || []).filter(Boolean));
      const lastDay = new Date(year, month + 1, 0).getDate();
      for (let day = 1; day <= lastDay; day += 1) {
        const date = new Date(year, month, day);
        const value = this.formatLocalDate(date);
        const unavailable = value < deliveryDate.dataset.earliestDelivery || unavailableDates.has(value);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ayabe-calendar__day';
        button.textContent = String(day);
        button.dataset.calendarDate = value;
        button.setAttribute('role', 'gridcell');
        button.setAttribute('aria-label', `${year}年${month + 1}月${day}日${unavailable ? ' 配達不可' : ''}`);
        button.disabled = unavailable;
        if (value === deliveryDate.value) {
          button.classList.add('is-selected');
          button.setAttribute('aria-selected', 'true');
        }
        grid.appendChild(button);
      }

      const previous = this.root.querySelector('[data-calendar-prev]');
      const next = this.root.querySelector('[data-calendar-next]');
      if (previous) previous.disabled = this.deliveryCalendarMonth <= minimumMonth;
      if (next) next.disabled = this.deliveryCalendarMonth >= maximumMonth;
      const selected = this.root.querySelector('[data-calendar-selected]');
      if (selected) selected.textContent = deliveryDate.value
        ? `選択中：${deliveryDate.value.replace(/-/g, '/')} お届け`
        : 'お届け日を選択してください。';
    }

    rebuildSteps() {
      const mode = this.state.fulfillment;
      const names = mode === 'delivery'
        ? ['method', 'delivery_datetime', 'delivery_address', 'product', 'color', 'price', 'details', 'customer', 'review']
        : mode === 'pickup'
          ? ['method', 'pickup_datetime', 'product', 'color', 'price', 'details', 'customer', 'review']
          : ['method'];
      this.steps = names.map((name) => this.root.querySelector(`[data-step="${name}"]`)).filter(Boolean);
      if (this.current >= this.steps.length) this.current = this.steps.length - 1;
      this.updatePrices();
      this.render();
    }

    updatePrices() {
      const allowed = this.state.fulfillment === 'delivery' ? this.config.deliveryPrices : this.config.pickupPrices;
      this.root.querySelectorAll('[data-price-choice]').forEach((choice) => {
        const visible = allowed.includes(Number(choice.dataset.priceChoice));
        choice.hidden = !visible;
        choice.querySelector('input').disabled = !visible;
      });
      if (this.state.price && !allowed.includes(Number(this.state.price))) {
        delete this.state.price;
        this.root.querySelectorAll('input[name="price"]').forEach((input) => input.checked = false);
      }
    }

    render() {
      this.root.querySelectorAll('[data-step]').forEach((panel) => panel.classList.remove('is-active'));
      const panel = this.steps[this.current] || this.steps[0];
      panel?.classList.add('is-active');
      const total = this.steps.length;
      const position = this.current + 1;
      this.root.querySelector('[data-progress-bar]').style.width = `${(position / total) * 100}%`;
      this.root.querySelector('[data-progress-label]').textContent = `STEP ${position} / ${total}`;
      if (panel?.dataset.step === 'review') this.renderReview();
      panel?.querySelector('h2')?.focus({ preventScroll: true });
      window.scrollTo({ top: this.root.offsetTop - 20, behavior: 'smooth' });
    }

    requiredFields(panel) {
      return [...panel.querySelectorAll('[data-required]')].filter((field) => !field.disabled);
    }

    validate(panel) {
      const radioNames = new Set();
      for (const field of this.requiredFields(panel)) {
        if (field.type === 'radio') {
          if (radioNames.has(field.name)) continue;
          radioNames.add(field.name);
          if (!panel.querySelector(`input[name="${field.name}"]:checked`)) return false;
        } else if (!field.value.trim()) return false;
        else if (!field.checkValidity()) return false;
      }
      if (panel.dataset.step === 'delivery_address' && !this.checkPostcode(false)) return false;
      if (panel.dataset.step === 'price' && !this.findVariant()) {
        this.showError('選択した商品に、この価格の購入可能なバリエーションがありません。Shopifyの商品設定をご確認ください。');
        return false;
      }
      return true;
    }

    next() {
      const panel = this.steps[this.current];
      this.clearError();
      if (!this.validate(panel)) {
        if (!this.root.querySelector('.ayabe-order__error.is-visible')) this.showError('必須項目を入力・選択してください。');
        return;
      }
      if (this.current < this.steps.length - 1) {
        this.current += 1;
        this.render();
      }
    }

    back() {
      this.clearError();
      if (this.current > 0) {
        this.current -= 1;
        this.render();
      }
    }

    normalizePostcode(value) {
      return String(value || '').replace(/\D/g, '');
    }

    checkPostcode(showMessage) {
      const input = this.root.querySelector('[name="delivery_postcode"]');
      const result = this.root.querySelector('[data-address-result]');
      const postcode = this.normalizePostcode(input?.value);
      if (postcode.length !== 7) {
        if (showMessage || postcode) {
          result.className = 'ayabe-order__address-result is-error';
          result.textContent = '郵便番号を7桁で入力してください。';
        }
        return false;
      }
      const allowed = this.config.allowedPostcodes.includes(postcode);
      if (!allowed) {
        result.className = 'ayabe-order__address-result is-error';
        result.textContent = '申し訳ありません。配達は綾部市・福知山市内に限らせていただいております。この郵便番号は配達対象外です。';
        return false;
      }
      const blocked = this.config.unavailablePostcodes.includes(postcode);
      if (blocked) {
        result.className = 'ayabe-order__address-result is-error';
        result.textContent = '申し訳ありません。この郵便番号は現在の配達対象外です。';
        return false;
      }
      const fee = this.config.highFeePostcodes.includes(postcode) ? 1000 : 500;
      this.state.delivery_postcode = postcode;
      this.state.delivery_fee = fee;
      result.className = 'ayabe-order__address-result is-ok';
      result.textContent = `配達可能です。通常配送料は税込${fee.toLocaleString('ja-JP')}円です。商品代金が税込11,000円以上の場合は配送料が無料になります。`;
      return true;
    }

    effectiveDeliveryFee() {
      if (this.state.fulfillment !== 'delivery') return 0;
      return Number(this.state.price || 0) >= 11000 ? 0 : Number(this.state.delivery_fee || 500);
    }

    product() {
      if (!this.state.fulfillment || !this.state.product_type) return null;
      return this.config.products[`${this.state.fulfillment}_${this.state.product_type}`];
    }

    findVariant() {
      const product = this.product();
      if (!product || !this.state.price) return null;
      return product.variants.find((variant) => variant.available && variant.price === Number(this.state.price));
    }

    renderProductPreview() {
      const previews = this.root.querySelectorAll('[data-product-preview]');
      const product = this.product();
      if (!product) {
        previews.forEach((preview) => preview.hidden = true);
        return;
      }
      const variant = this.findVariant();
      const image = variant?.image || product.image;
      previews.forEach((preview) => {
        preview.hidden = false;
        preview.querySelector('img').src = image || this.config.placeholder;
        preview.querySelector('img').alt = product.title;
        preview.querySelector('[data-preview-title]').textContent = product.title;
        preview.querySelector('[data-preview-note]').textContent = variant
          ? `税込${variant.price.toLocaleString('ja-JP')}円のボリュームイメージ`
          : '価格を選ぶと、該当する商品バリエーションを表示します。';
      });
    }

    renderReview() {
      const product = this.product();
      const values = {
        fulfillment: this.state.fulfillment === 'delivery' ? '配達' : '綾部店で受取',
        datetime: this.state.fulfillment === 'delivery'
          ? `${this.state.delivery_date || ''} ${this.state.delivery_time || ''}`
          : `${this.state.pickup_date || ''} ${this.state.pickup_time || ''}`,
        destination: this.state.fulfillment === 'delivery'
          ? `${this.state.recipient_name || ''}\n〒${this.state.delivery_postcode || ''} 京都府${(this.state.delivery_postcode || '').startsWith('623') ? '綾部市' : '福知山市'}${this.state.delivery_address || ''}\n${this.state.recipient_phone || ''}`
          : 'フラワーショップおおつき 綾部店',
        product: product?.title || '',
        color: this.state.color || '',
        price: this.state.price ? `税込${Number(this.state.price).toLocaleString('ja-JP')}円` : '',
        fee: this.state.fulfillment === 'delivery'
          ? this.effectiveDeliveryFee() === 0
            ? '無料（商品代金 税込11,000円以上）'
            : `税込${this.effectiveDeliveryFee().toLocaleString('ja-JP')}円`
          : 'なし',
        details: `用途：${this.state.purpose || '指定なし'}\n雰囲気：${this.state.mood || 'おまかせ'}\nメッセージ：${this.state.message || 'なし'}\nご要望：${this.state.request || 'なし'}`,
        customer: `${this.state.customer_name || ''}\n${this.state.customer_phone || ''}\n${this.state.customer_email || ''}`
      };
      Object.entries(values).forEach(([key, value]) => {
        const node = this.root.querySelector(`[data-review="${key}"]`);
        if (node) node.textContent = value;
      });
      const paymentNote = this.root.querySelector('[data-payment-note]');
      const reviewLead = this.root.querySelector('[data-review-lead]');
      if (reviewLead) reviewLead.textContent = '内容を確認後、Shopifyの安全な決済画面へ進みます。';
      paymentNote.textContent = this.state.fulfillment === 'delivery'
        ? '配達注文では店頭支払いをご利用いただけません。Shopifyの決済画面でオンライン決済または銀行振込を選択してください。'
        : 'Shopifyの決済画面で、オンライン決済・銀行振込・店頭支払いから選択してください。店頭支払いの場合は、商品受取時に綾部店のレジでお支払いください。';
      const bankNotice = this.root.querySelector('[data-bank-transfer-notice]');
      if (bankNotice) bankNotice.hidden = false;
      const submit = this.root.querySelector('[data-submit]');
      if (submit) {
        submit.hidden = false;
        submit.textContent = 'Shopifyの決済画面へ進む';
      }
    }

    lineProperties() {
      const properties = {
        '受取方法': this.state.fulfillment === 'delivery' ? '配達' : '綾部店で受取',
        '色味': this.state.color,
        '用途': this.state.purpose || '指定なし',
        '雰囲気': this.state.mood || 'おまかせ',
        'メッセージカード': this.state.message || 'なし',
        'ご要望': this.state.request || 'なし',
        '受取・お届け日': this.state.fulfillment === 'delivery' ? this.state.delivery_date : this.state.pickup_date,
        '受取・お届け時間': this.state.fulfillment === 'delivery' ? this.state.delivery_time : this.state.pickup_time
      };
      if (this.state.fulfillment === 'delivery') {
        Object.assign(properties, {
          'お届け先様氏名': this.state.recipient_name,
          'お届け先郵便番号': this.state.delivery_postcode,
          'お届け先住所': this.state.delivery_address,
          'お届け先電話番号': this.state.recipient_phone
        });
      }
      return properties;
    }

    cartAttributes() {
      const attributes = {
        '綾部店注文_受取方法': this.state.fulfillment === 'delivery' ? '配達' : '店頭受取',
        'ayabe_fulfillment': this.state.fulfillment === 'delivery' ? 'delivery' : 'pickup',
        '綾部店注文_注文者名': this.state.customer_name,
        '綾部店注文_注文者電話': this.state.customer_phone,
        '綾部店注文_注文者メール': this.state.customer_email
      };
      if (this.state.fulfillment === 'delivery') {
        Object.assign(attributes, {
          '綾部店注文_お届け先様氏名': this.state.recipient_name,
          '綾部店注文_お届け先郵便番号': this.state.delivery_postcode,
          '綾部店注文_お届け先住所': this.state.delivery_address,
          '綾部店注文_お届け先電話': this.state.recipient_phone,
          '綾部店注文_配送料': this.effectiveDeliveryFee() === 0 ? '無料' : `${this.effectiveDeliveryFee()}円`
        });
      }
      return attributes;
    }

    base64Url(value) {
      const bytes = new TextEncoder().encode(value);
      let binary = '';
      bytes.forEach((byte) => binary += String.fromCharCode(byte));
      return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
    }

    japanPhone(value) {
      const raw = String(value || '').trim();
      if (raw.startsWith('+81')) return raw.replace(/[^\d+]/g, '');
      const digits = raw.replace(/\D/g, '');
      return digits.startsWith('0') ? `+81${digits.slice(1)}` : digits;
    }

    shippingAddressParts() {
      const postcode = this.state.delivery_postcode || '';
      const city = postcode.startsWith('623') ? '綾部市' : '福知山市';
      let address = String(this.state.delivery_address || '').trim();
      address = address.replace(/^京都府\s*/, '');
      address = address.replace(new RegExp(`^${city}\\s*`), '');
      const parts = address.split(/[\s　]+/).filter(Boolean);
      return {
        city,
        address1: parts.shift() || address,
        address2: parts.join(' ')
      };
    }

    async submit() {
      this.clearError();
      const consent = this.root.querySelector('[name="terms_consent"]');
      if (!consent.checked) {
        this.showError('注意事項をご確認のうえ、同意欄にチェックしてください。');
        return;
      }
      const variant = this.findVariant();
      if (!variant) {
        this.showError('商品バリエーションを確認できませんでした。');
        return;
      }
      const itemParts = [`${variant.id}:1`];
      if (this.state.fulfillment === 'delivery' && this.effectiveDeliveryFee() > 0) {
        const feeVariant = Number(this.state.delivery_fee) === 1000 ? this.config.feeVariants.high : this.config.feeVariants.standard;
        if (!feeVariant) {
          this.showError('配送料商品の設定が完了していません。店舗へお問い合わせください。');
          return;
        }
        itemParts.push(`${feeVariant}:1`);
      }
      const submit = this.root.querySelector('[data-submit]');
      submit.disabled = true;
      this.root.querySelector('[data-loading]').classList.add('is-visible');
      const params = new URLSearchParams();
      params.set('properties', this.base64Url(JSON.stringify(this.lineProperties())));
      params.set('checkout[email]', this.state.customer_email);
      Object.entries(this.cartAttributes()).forEach(([key, value]) => {
        if (value) params.set(`attributes[${key}]`, value);
      });
      if (this.state.fulfillment === 'delivery') {
        const shippingAddress = this.shippingAddressParts();
        params.set('checkout[shipping_address][last_name]', this.state.recipient_name);
        params.set('checkout[shipping_address][address1]', shippingAddress.address1);
        if (shippingAddress.address2) {
          params.set('checkout[shipping_address][address2]', shippingAddress.address2);
        }
        params.set('checkout[shipping_address][city]', shippingAddress.city);
        params.set('checkout[shipping_address][province]', '京都府');
        params.set('checkout[shipping_address][country]', 'Japan');
        params.set('checkout[shipping_address][zip]', this.state.delivery_postcode);
        params.set('checkout[shipping_address][phone]', this.japanPhone(this.state.recipient_phone));
      }
      try {
        const clearResponse = await fetch(this.config.cartClearUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
        });
        if (!clearResponse.ok) throw new Error('以前のカート内容を消去できませんでした。');
        window.location.assign(`${this.config.cartPermalinkBase}/${itemParts.join(',')}?${params.toString()}`);
      } catch (error) {
        submit.disabled = false;
        this.root.querySelector('[data-loading]').classList.remove('is-visible');
        this.showError(error.message || 'チェックアウトを準備できませんでした。');
      }
    }

    showError(message) {
      const error = this.root.querySelector('[data-error]');
      error.textContent = message;
      error.classList.add('is-visible');
      error.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    clearError() {
      const error = this.root.querySelector('[data-error]');
      error.textContent = '';
      error.classList.remove('is-visible');
    }
  }

  const initializeAyabeOrders = () => {
    document.querySelectorAll('[data-ayabe-order]').forEach((root) => {
      try {
        if (root.__ayabeOrder) {
          root.__ayabeOrder.rebuildSteps();
          root.__ayabeOrder.render();
        } else {
          new AyabeOrder(root);
        }
      } catch (error) {
        console.error('綾部店注文フォームを初期化できませんでした。', error);
        root.querySelector('[data-step="method"]')?.classList.add('is-active');
      }
    });
  };

  initializeAyabeOrders();
  document.addEventListener('DOMContentLoaded', initializeAyabeOrders);
  window.addEventListener('pageshow', () => {
    initializeAyabeOrders();
    document.querySelectorAll('[data-ayabe-order]').forEach((root) => {
      root.querySelectorAll('[data-step]').forEach((panel) => panel.classList.remove('is-active'));
      root.querySelector('[data-step="method"]')?.classList.add('is-active');
      const loading = root.querySelector('[data-loading]');
      loading?.classList.remove('is-visible');
      if (root.__ayabeOrder) {
        root.__ayabeOrder.current = 0;
        root.__ayabeOrder.render();
      }
    });
  });
  document.addEventListener('shopify:section:load', initializeAyabeOrders);

  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => [...mutation.addedNodes].some((node) =>
      node.nodeType === 1 && (node.matches?.('[data-ayabe-order]') || node.querySelector?.('[data-ayabe-order]'))
    ))) {
      initializeAyabeOrders();
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
